import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools, faHome, faInfoCircle, faClipboardList, faEdit } from "@fortawesome/free-solid-svg-icons"; // Added relevant icons
import { StandardURL } from "../App";


const MaintenancePage = () => {
  const navigate = useNavigate();
  const [maintenanceRequests, setMaintenanceRequests] = useState([]);

  useEffect(() => {
    // Retrieve propertyId and token from local storage
    const propertyId = localStorage.getItem("selectedPropertyId");
    const token = localStorage.getItem("token");

    // Fetch maintenance requests using axios
    axios
      .get(
        `${StandardURL}/iNyumba/maintenance/properties/${propertyId}/maintenance-requests`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setMaintenanceRequests(response.data.response);
      })
      .catch((error) => {
        console.error("Error fetching maintenance requests:", error);
      });
  }, []);

  const handleUpdateClick = (requestId) => {
    localStorage.setItem("selectedMaintenanceRequestId", requestId);
    navigate("/landlord/updatemaintenance");
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-100 p-4 sm:p-6 lg:p-8">
          <div className="max-w-4xl mx-auto bg-white p-6 sm:p-8 rounded-xl shadow-2xl border border-gray-200">
            {/* --- Header Section --- */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight flex items-center">
                Maintenance Requests <FontAwesomeIcon icon={faTools} className="ml-4 text-green-600" />
              </h1>
            </div>

            <p className="text-gray-600 mb-8 max-w-3xl mx-auto text-center">
              View and manage all active maintenance requests. Click "Update Request" to modify its details or status.
            </p>

            {/* --- Maintenance Requests List --- */}
            <div className="space-y-6">
              {maintenanceRequests.length > 0 ? (
                maintenanceRequests.map((request) => (
                  <div
                    key={request.id}
                    className="bg-gray-50 border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-200 ease-in-out"
                  >
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 border-b pb-3">
                      <h2 className="text-2xl font-bold text-blue-700 flex items-center mb-2 sm:mb-0">
                        <FontAwesomeIcon icon={faClipboardList} className="mr-3 text-blue-500" />
                        {request.title}
                      </h2>
                      <span
                        className={`px-4 py-1 rounded-full text-sm font-semibold whitespace-nowrap
                          ${request.status === "Pending" ? "bg-yellow-100 text-yellow-800" :
                            request.status === "In Progress" ? "bg-blue-100 text-blue-800" :
                            request.status === "Completed" ? "bg-green-100 text-green-800" :
                            "bg-gray-100 text-gray-800"
                          }`}
                      >
                        Status: {request.status}
                      </span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                      <div>
                        <p className="text-gray-600 text-sm font-medium mb-1 flex items-center">
                          <FontAwesomeIcon icon={faInfoCircle} className="mr-2 text-gray-500" />
                          Description:
                        </p>
                        <p className="text-gray-800 bg-gray-100 p-3 rounded-md border border-gray-200 text-sm">
                          {request.request_content || "No description provided."}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-600 text-sm font-medium mb-1 flex items-center">
                          <FontAwesomeIcon icon={faHome} className="mr-2 text-gray-500" />
                          House Number:
                        </p>
                        <p className="text-gray-800 bg-gray-100 p-3 rounded-md border border-gray-200 text-lg font-semibold">
                          {request.house_no}
                        </p>
                      </div>
                    </div>

                    <div className="flex justify-end pt-4 border-t">
                      <button
                        onClick={() => handleUpdateClick(request.request_id)}
                        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                      >
                        <FontAwesomeIcon icon={faEdit} className="mr-2" />
                        Update Request
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="bg-white p-8 rounded-lg shadow-md text-center text-lg text-gray-500 italic">
                  <div className="flex flex-col items-center justify-center">
                    <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path></svg>
                    No maintenance requests found.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default MaintenancePage;
